import {createContext} from 'react';

const userPermissionContext = createContext();

export default userPermissionContext;